module.exports = __webpack_public_path__ + "img/arrow-chevron-right.a99bd2b4.svg";